const Loading = () => {
  return (
    <div className="overlay loading">
      <div className="loader"/>
    </div>
  )
}

export default Loading;
